// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/widget-definition.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { widgetDefinitionsApi } from "../../api/widget-definitions";
import type { WidgetDefinition } from "../../api/types";
// override-block:imports BEGIN
// CHG-2471 / ITER-905213 — Widget Studio S5. family renders as a chip
// (`chip` is not a built-in cell type → custom column + render helper).
import type { ReactNode } from "react";
import { chipCell } from "../../lib/widget-cells";
// override-block:imports END

// override-block:helpers BEGIN
function familyColumn(row: WidgetDefinition): ReactNode {
  return chipCell(row.family);
}
// override-block:helpers END

export const widgetDefinitionListConfig: ListPageConfig<WidgetDefinition> = {
  title: "Widget catalog",
  subtitle: "The platform-global catalog of widget types (read-only).",
  queryKey: ["widget-definitions", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search, filters }) =>
    widgetDefinitionsApi.listWidgetDefinitions({ page, pageSize, sortField, sortDirection, search, filters }),
  defaultSort: { field: "display_name", direction: "asc" },
  pageSize: 50,
  rowHref: "/channels/widgets/catalog/{id}",
  search: { enabled: true, placeholder: "Search the catalog by name or key…" },
  emptyState: {
    title: "No widget definitions",
    subtitle: "The widget type catalog is seeded platform-wide.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  filters: [
    { field: "family", label: "Family", type: "select", options: [{ value: "announcement", label: "Announcement" }, { value: "social_post", label: "Social post" }, { value: "event", label: "Event" }, { value: "donation", label: "Donation" }] },
    { field: "status", label: "Status", type: "select", options: [{ value: "active", label: "Active" }, { value: "inactive", label: "Inactive" }, { value: "deprecated", label: "Deprecated" }] },
  ],
  columns: [
    { field: "display_name", label: "Name", type: "text", sortable: true },
    { field: "family", label: "Family", type: "custom", render: familyColumn },
    { field: "module", label: "Module", type: "text" },
    { field: "widget_key", label: "Key", type: "text" },
    { field: "status", label: "Status", type: "lifecycle-badge" },
  ],
};
